import core from '@/helpers/client'

const productRegisterDraftService = {
  async createProductRegisterDraftsOFMStockAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/bulk/OFMStock`,
      model
    )
    return result
  },
  async createProductRegisterDraftsDropShipAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/bulk/DropShip`,
      model
    )
    return result
  },
  async updateProductRegisterDraftAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/savedraft`,
      model
    )
    return result
  },
  async deleteProductRegisterDraftByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/delete/${id}`
    )
    return result
  },
  async validateProductRegisterDraftsOFMStockAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/bulk/validate/OFMStock`,
      model
    )
    return result
  },
  async validateProductRegisterDraftsDropShipAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/bulk/validate/DropShip`,
      model
    )
    return result
  },
  async getProductRegisterDraftListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts`,
      params
    )
    return result
  },
  async getProductRegisterDraftByIdAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/${id}`
    )
    return result
  },
  async createProductRegisterDraftsImportOFMStockAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/bulk/ImportOFMStock`,
      model,null,false
    )
    return result
  },
  async createProductRegisterDraftsImportDropShipAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductRegisterDrafts/bulk/ImportDropShip`,
      model,null,false
    )
    return result
  },
}

export default productRegisterDraftService
